import React, { Component } from "react";

class Gallery extends Component {
    render() {
	return (<div>gallery package</div>);
    }
}

export default Gallery;
